import { InjectionToken } from '@angular/core';

export const CURSOR_OFFSET = 12;

export const POPPER_CONTENT = new InjectionToken<string>('POPPER_CONTENT');
